import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import ProductionComponent from '../components/production.component';
import { selectProductionsQueryItems } from '../../../../../redux/productions/selector';
import { productions } from '../../../../../redux/productions/action';

const ManagementProductionSettings = () => {
  const dispatch = useAppDispatch()
  const productionSettingsQuery = useSelector(selectProductionsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectProductionSettings, setSelectProductionSettings] = useState<any>([])

  const fetchProductionSettingsQueryById = () => {
    dispatch(productions.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/productions/query`,
      entity: 'productions',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectProductionSettings({ ...selectProductionSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchProductionSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectProductionSettings(productionSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(productions.resetAction({ actionType: 'update' }))
    await dispatch(productions.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/productions`,
      entity: 'productions',
      jsonData: {
        Records: [
          selectProductionSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ProductionComponent
          handleInnerFormChange={handleInnerFormChange}
          selectProductionSettings={selectProductionSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementProductionSettings;